"use strict";

exports.__esModule = true;
exports.alertsDefinition = void 0;
var _react = _interopRequireDefault(require("react"));
var _vimanaTypes = require("@vimana/vimana-types");
var _AlertDetails = require("../../../Alerts/AlertDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var alertsDefinition = exports.alertsDefinition = function alertsDefinition(translate) {
  return {
    columns: [{
      id: "created",
      name: translate("DataTable.Column.Title.created", "Created At"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "description",
      name: translate("DataTable.Column.Title.description", "Description"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "name",
      name: translate("DataTable.Column.Title.name", "Name"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "plant",
      name: translate("DataTable.Column.Title.plant", "Plant"),
      type: "string",
      canFilter: false
    }, {
      id: "deviceName",
      sortId: "device.value",
      name: translate("DataTable.Column.Title.deviceName", "Device"),
      type: "deviceName",
      canSearch: true,
      canFilter: true
    }, {
      id: "acknowledged",
      sortId: "alert.acknowledged",
      name: translate("DataTable.Column.Title.acknowledged", "Acknowledged"),
      type: "boolean",
      canSearch: false,
      canFilter: true,
      showSearchFilter: false
    }, {
      id: "deviceId",
      sortId: "device.value",
      name: translate("DataTable.Column.Title.deviceId", "Device UUID"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: false
    }, {
      id: "tags",
      name: translate("DataTable.Column.Title.tags", "Tags"),
      type: "string",
      canFilter: true,
      canSearch: true
    }],
    SubComponent: function SubComponent(props) {
      var _props$rowData = props.rowData,
        row = _props$rowData.row,
        toggleRowSubComponent = _props$rowData.toggleRowSubComponent,
        nestingPath = _props$rowData.nestingPath,
        width = props.width,
        height = props.height,
        refreshData = props.refreshData;
      var alertId = row._original.id; // Depends on internal DS of react table
      return /*#__PURE__*/_react["default"].createElement(_AlertDetails.AlertDetails, {
        alertId: alertId,
        width: width,
        height: height,
        refreshData: refreshData,
        onClose: function onClose(e) {
          return toggleRowSubComponent({
            nestingPath: nestingPath
          }, e);
        }
      });
    },
    parseData: function parseData(responseData) {
      return {
        acknowledged: responseData.acknowledged,
        id: responseData.id,
        created: responseData.created,
        description: responseData.description,
        name: responseData.name,
        plant: responseData.plant,
        deviceId: responseData.device.value,
        deviceName: responseData.device.value,
        tags: responseData.tags.join(",")
      };
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: false,
        defaultPageSize: "auto",
        columns: [{
          id: "description",
          name: translate("DataTable.Column.Title.description", "Description"),
          type: "string",
          enableSorting: true
        }, {
          id: "created",
          name: translate("DataTable.Column.Title.created", "Created At"),
          type: "date",
          usePlantTime: true,
          defaultSortOrder: "ASC",
          // this is to match with the server, without it the server returns it's default forcing a double request to occur
          enableSorting: true
        }, {
          id: "deviceName",
          name: translate("DataTable.Column.Title.deviceName", "Device"),
          type: "deviceName",
          enableSorting: true
        }, {
          id: "acknowledged",
          name: translate("DataTable.Column.Title.acknowledged", "Acknowledged"),
          type: "boolean",
          enableSorting: false
        }, {
          id: "tags",
          name: translate("DataTable.Column.Title.tags", "Tags"),
          type: "string",
          enableSorting: false
        }]
      };
    }
  };
};